import React from 'react';
import { Box } from '@mui/material';

import { StatusChip, Typography } from '@occc/ui-design-system';
import { CampaignFragment } from '@occc/graphql';

export const PageTitle: React.FC<{ campaign?: CampaignFragment | null }> = ({ campaign }) => {
  if (!campaign) {
    return <>Campaign Details</>;
  }

  return (
    <Box display='flex' alignItems='center'>
      <Typography variant='h4'>{campaign.name}</Typography>
      {campaign.category && (
        <Box display='flex' alignItems='center' ml={1}>
          <StatusChip label={campaign.category} variant='success' />
        </Box>
      )}
      {campaign.externalId && (
        <Box display='flex' alignItems='center' ml={1}>
          <StatusChip label={campaign.externalId} variant='info' />
        </Box>
      )}
    </Box>
  );
};
